import { SegmentEnum } from './segment.enum';
export class DealADartPlayer {
    constructor(name, single, double, triple) {
        this.rounds = [];
        this.name = name;
        this.rounds.push(new DealADartRound(SegmentEnum.SINGLE, single, false));
        this.rounds.push(new DealADartRound(SegmentEnum.DOUBLE, double, false));
        this.rounds.push(new DealADartRound(SegmentEnum.TRIPLE, triple, false));
    }
}
export class DealADartRound {
    constructor(segment, number, hit) {
        this.segment = segment;
        this.number = number;
        this.hit = hit;
    }
}
export class HistoryEvent {
    constructor(type, playerIndex, segment) {
        this.type = type;
        this.playerIndex = playerIndex;
        this.segment = segment;
    }
}
